import api from '../Api';
import { IStorefrontEditLeaseStatus } from '../../models/Storefront';

// The storefront edit lease, read-side only.
//
// The AI design assistant takes a short lease on a storefront for the length of one restyle turn.
// While it holds one, every storefront write endpoint answers a human's save with a 409. The editors
// poll this query so they can go read-only up front rather than letting somebody spend a minute on
// changes that the save then rejects.
//
// Deliberately carries NO cache tags. A lease is short-lived state that nothing in this app mutates,
// so there is no write to invalidate against; freshness comes from the poll interval the hook sets,
// and skipping tags keeps this out of the way of the invalidation graph in Api.ts.
const storefrontLeaseApi = api.injectEndpoints({
    endpoints: (build) => ({
        // Answers for the caller's own organization; the storefront id is the only argument. A
        // coordination outage is reported by the API as "not locked" rather than an error, so a
        // rejected request here means something else went wrong and the hook treats it as unlocked.
        getStorefrontEditLease: build.query<IStorefrontEditLeaseStatus, string>({
            query: (storefront) => `storefront/storefronts/${storefront}/edit-lease`,
        }),
    }),
    overrideExisting: false,
})

export const { useGetStorefrontEditLeaseQuery } = storefrontLeaseApi
